import React from 'react';
import * as PageStructures from '../../structure/PageStructures';
import Event from '../../events/Event/Event';
import { EventProps } from '../../events/Event/Event.types';
import { DirectoryShortListProvider } from '../../contexts/DirectoryShortListProvider/DirectoryShortListProvider';
import { BreadcrumbProp } from '../../structure/Breadcrumbs/Breadcrumbs.types';
import WarningText from '../../slices/WarningText/WarningText';

interface EventPageProps {
  event: EventProps;
  breadcrumbs?: BreadcrumbProp[];
  footerLinks?: Array<{ title: string; url: string }>;
}

const defaultBreadcrumbs: BreadcrumbProp[] = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Events',
    url: '/events',
  },
];

const defaultFooterLinks = [
  {
    title: 'About',
    url: '/',
  },
  {
    title: 'Accessibility',
    url: '/',
  },
  {
    title: 'Cookies',
    url: '/',
  },
  {
    title: 'Contact us',
    url: '/',
  },
  {
    title: 'Jobs',
    url: '/',
  },
  {
    title: 'Newsletter',
    url: '/',
  },
];

export const EventPage: React.FunctionComponent<EventPageProps> = ({
  event,
  breadcrumbs = defaultBreadcrumbs,
  footerLinks = defaultFooterLinks,
}) => (
  <>
    <PageStructures.Header />
    <PageStructures.MaxWidthContainer>
      <PageStructures.PageMain>
        <PageStructures.Breadcrumbs breadcrumbsArray={breadcrumbs} hasMargin />
        <DirectoryShortListProvider>
          <Event {...event} />
        </DirectoryShortListProvider>
        {event.updatedAt && (
          <p>
            <PageStructures.DisplayDate preText="Last updated " text={event.updatedAt} format="YYYY-MM-DD" />
          </p>
        )}
      </PageStructures.PageMain>
    </PageStructures.MaxWidthContainer>
    <PageStructures.Footer footerLinksArray={footerLinks} />
  </>
);